import _instagram from '../services/instagram-image'

const ImageInstagram = {
	install: function (Vue, options) {
		Vue.$image_instagram = _instagram
	},
}

export default ImageInstagram
